'use strict';

var _Constants = require('./Constants');

// constants for Google Analytics Property and Measurement Protocol
var config = {
    version: 1 // The Google Measurement Protocol version. The current value is '1'. This will only change when there are changes made that are not backwards compatible.
};

module.exports = function (options) {

    /**
     * This class can be used to generate new purchase advanced ecommerce events
     * to use pass in an object that may include any of the following hit parameters
     * see https://developers.google.com/analytics/devguides/collection/protocol/v1/parameters#cu for Google's documentation on Measurement Protocol api for Enhanced E-Commerce
     *
     * @param {Object} which provides necessary values to build up the hit payload
     * {
    *      googleAnalyticsPropertyId: <[id1, id2, id3 ... idn]>  /pass in 1 or more ids and a separate hit will be generated, one for each Google Property indicated by id
    *      page: <webPageUrl>,
    *      clientId: <identifiesDevice>
    *      transactionId: <putYourIdHere>,
    *      transactionAffiliation: <Specifies the affiliation or store name>,
    *      transactionRevenue: <Specifies the total revenue associated with the transaction. This value should include any shipping or tax costs>,
    *      transactionTax: <Specifies the total tax of the transaction>,
    *      transactionShipping: <Specifies the total shipping cost of the transaction>,
    *      currencyCode: <When present indicates the local currency for all transaction currency values. Value should be a valid ISO 4217 currency code> passing a string 'undefined' will cause products to show up as $0.00 in product revenue
    *      accountId: <Custom Dimension defined in the Google Analytics Account, is 'vendorId' unique to each rewards account holder>
    *      couponCode: <transactionCouponCode>
    *      ipAddress: <kioskIPAddress>
    *      products: [{
    *          id: <yourItemIdHere>,
    *          name: <yourItemNameHere>,
    *          price: <yourItemPriceHere>,
    *          category: <yourProductCategory>,
    *          brand: <yourProductBrand>,
    *          variant: <yourProductVariant>,
    *          quantity: <quantityOfProduct>,
    *          couponCode: <productCouponCode>
    *
    *      }],
    * }
     * @returns [{Objects}] with key values corresponding to Google Analytics Measurement Protocol API, values from the app data
     *  see https://developers.google.com/analytics/devguides/collection/protocol/v1/parameters#cu
     */
    this.makePurchaseEvents = function (hitDescription) {

        var purchaseEvents = [];

        options.googleAnalyticsPropertyIds.forEach(function (propertyId) {

            var purchaseEvent = {
                v: config.version,
                tid: propertyId,
                dl: hitDescription.page,
                t: _Constants.EVENT,
                ec: _Constants.ENHANCED_ECOMMERCE,
                ea: _Constants.PURCHASE_EVENT_ACTION,
                pa: _Constants.PURCHASE_PRODUCT_ACTION,
                cid: hitDescription.clientId,

                ti: hitDescription.transactionId,
                tr: hitDescription.transactionRevenue,
                ta: hitDescription.transactionAffiliation,
                tt: hitDescription.transactionTax,
                ts: hitDescription.transactionShipping,
                cu: hitDescription.currencyCode.toLowerCase() === 'cad' || hitDescription.currencyCode.toLowerCase() === 'usd' ? hitDescription.currencyCode.toUpperCase() : 'USD', // if any value that is not a valid ISO 4217 currency code is passed in, product data will be inacurate with product and total revenue showing $0 even if they have positive values in the hit
                cd1: hitDescription.wendysVendorId,

                ds: options.dataSource,
                sc: 'end' // session control, you can start or end a session on a hit by passing either value; here we end a session with the purchase event
            };

            hitDescription.products && hitDescription.products.forEach(function (product, index) {
                purchaseEvent['pr' + (index + 1) + 'id'] = hitDescription.products[index].id;
                purchaseEvent['pr' + (index + 1) + 'nm'] = hitDescription.products[index].name;
                purchaseEvent['pr' + (index + 1) + 'ca'] = hitDescription.products[index].category;
                purchaseEvent['pr' + (index + 1) + 'va'] = hitDescription.products[index].variant;
                purchaseEvent['pr' + (index + 1) + 'br'] = hitDescription.products[index].brand;
                purchaseEvent['pr' + (index + 1) + 'pr'] = hitDescription.products[index].price;
                purchaseEvent['pr' + (index + 1) + 'qt'] = hitDescription.products[index].quantity;
                purchaseEvent['pr' + (index + 1) + 'cc'] = hitDescription.products[index].couponCode ? hitDescription.products[index].couponCode : null;
            });

            purchaseEvents.push(purchaseEvent);
        });

        return purchaseEvents;
    };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/analytics/GoogleMeasurementProtocolProvider.js
// module id = 860
// module chunks = 0